import '.a{display:flex;}.ssr-plugin'
import '.q{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.am{gap:0.5rem;}.ssr-plugin'
import '.as{cursor:pointer;}.ssr-plugin'
import '.hy{padding:0.75rem;}.ssr-plugin'
import '.ag{border-radius:1.25rem;}.ssr-plugin'
import '.an{border:var(--blue-border);}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.d1{transition:background-color 0.2s ease;}.ssr-plugin'
import '.ec{width:2.5rem;}.ssr-plugin'
import '.ed{height:2.5rem;}.ssr-plugin'
import '.hz{color:var(--shades-blue-700);}.ssr-plugin'
import '.i0{font-size:0.9rem;}.ssr-plugin'
import '.ba{font-weight:400;}.ssr-plugin'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { styled } from 'inlines'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { MouseEventHandler } from 'react'

export type SocialMediaButtonProps = {
  icon: IconProp
  label: string
  onClick: MouseEventHandler<HTMLButtonElement>
  isMobile?: boolean
}

export const SocialMediaButton = ({
  icon,
  label,
  onClick,
  isMobile,
}: SocialMediaButtonProps) => {
    return (
      <styled.button className="a q b c am as hy ag an ah d1"
        style={{
          '&:hover': {
            backgroundColor: 'var(--shades-blue-50)',
          },
          width: isMobile ? '8rem' : '5.5rem',
          height: isMobile ? '8rem' : '5.5rem',
        }}
        onClick={onClick}
      >
        <div className="ec ed a c q hz"
          style={{
            fontSize: isMobile ? '3rem' : '2rem',
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
        <span className="i0 hz ba"
        >
          {label}
        </span>
      </styled.button>
    )
}